import React, { useRef } from "react";
import {
  Box,
  TextField,
  FormControl,
  InputAdornment,
  InputLabel,
  Input,
  IconButton,
  Button,
  Typography,
  Select,
  MenuItem,
  FormHelperText,
  Alert,
  Tabs,
  Tab,
  Modal as MuiModal,
  Stack,
} from "@mui/material";
import {
  AccountCircleOutlined,
  Visibility,
  VisibilityOff,
  LockOutlined,
  Group,
  Close as CloseIcon,
} from "@mui/icons-material";
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { set, range } from "lodash";
import { Grid } from "../../../components/table";
import { CONFIG } from "../../../../config";
import axios from "axios";
import { ToolBar } from "../../../components/toolbar";
import { Modal } from "../../../components/modal";
import { FormA, SelectA } from "../../../components/form";
import moment from "moment";
import { getFormState } from "../../../../helpers/form";
import dayjs from "dayjs";
import BoltIcon from "@mui/icons-material/Bolt";

import IosShareIcon from "@mui/icons-material/IosShare";
import PropTypes from "prop-types";
import { filterColumns } from "../column-manager";
import useDebounce from "../../../../hooks/useDebounce";
import { ManualInputBulkAssign } from "./features/bulk-assign/manual-input-bulk-assign";
import FormattedIdList from "./features/bulk-assign/formatted-id-list";
import BulkModalAssign from "./features/bulk-assign/bulk-assign-modal";
import { TransferredTab } from "./transferred/transferred-tab";
import SelectedAssignDialog from "../master-database/features/selected-assign-dialog"; // Added
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward"; // Added
import { toast } from "react-hot-toast"; // Added
import useModalState from "../../../../hooks/use-modal-state"; // Added
import ToolbarWrapper from "../../../components/toolbar-wrapper"; // Added
const durationPulgin = require("dayjs/plugin/duration");
dayjs.extend(durationPulgin);

const API_HOST = CONFIG.modules["accounts"].host;
const API_HOST_CRM = CONFIG.modules["crm"].host;

const centeredModalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: {
    xs: "90%",
    md: "70%",
  },
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  borderRadius: 2,
  p: 4,
};

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 1 }}>
          <Stack direction={"column"} spacing={2}>
            {children}
          </Stack>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const getTotalWeekOfCurrentMonth = () => {
  return Math.ceil(dayjs().daysInMonth() / 7);
};

const getWeekOfMonth = () => {
  return dayjs.duration().weeks();
};

export const Assigned = (props) => {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
        >
          <Tab label="IN PENDING" {...a11yProps(0)} />
          <Tab label="ATTEMPTED" {...a11yProps(1)} />
          <Tab label="TRANSFERRED" {...a11yProps(2)} />
          <Tab label="ON CALL" {...a11yProps(3)} />
        </Tabs>
      </Box>
      <CustomTabPanel value={value} index={0}>
        <List
          heading={""}
          sx={{ fontSize: ".1em" }}
          type={"in-queue"}
          socket={props.socket}
        />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <List heading={""} type={"attempted"} socket={props.socket} />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={2}>
        {/* <List heading={""} type={"transferred"} socket={props.socket} /> */}
        <TransferredTab socket={props.socket} />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={3}>
        <List heading={""} type={"on-call"} socket={props.socket} />
      </CustomTabPanel>
    </Box>
  );
};

export const List = ({ heading, type, socket }) => {
  const {
    roles,
    user,
    users,
    Designations,
    Departments,
    Languages,
    Districts,
    map,
    UnassignReasons,
  } = useSelector((state) => state.user || {});
  const userStore = useSelector((state) => state.user || {});
  console.log("length", dayjs.duration().asWeeks());

  const [listLoading, setListLoading] = useState(false);

  const [active, setActive] = useState("Employees");
  const [data, setData] = useState([]);
  const [open, setOpen] = useState(false);
  const [action, setAction] = useState("new");
  const [saved, setSaved] = useState(null);
  const [index, setIndex] = useState(null);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [assigning, setAssigning] = useState(false);
  const [assignCompleted, setAssignCompleted] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [unassignReason, setUnassignReason] = useState(null);
  const [unassignAllFiltered, setUnassignAllFiltered] = useState(false);
  const [allFilteredIds, setAllFilteredIds] = useState([]);

  // --- States for SelectedAssignDialog ---
  const [staticSelectedRows, setStaticSelectedRows] = useState(new Map());
  const [activeSelectedAssign, setActiveSelectedAssign] = useState(null);
  const [needToBeUnassignedCases, setNeedToBeUnassignedCases] = useState(
    new Map()
  );
  const [isFetchingSelectedCasesDetails, setIsFetchingSelectedCasesDetails] =
    useState(false);
  const [isUnassigningSelected, setIsUnassigningSelected] = useState(false); // Renamed from isUnassigning
  const [assignSelectedCompleted, setAssignSelectedCompleted] = useState(false);
  const [assigningSelected, setAssigningSelected] = useState(false);
  const [selectedAgents, setSelectedAgents] = useState({});
  // --- End States for SelectedAssignDialog ---

  // state for opening selective assigning dialog (Moved from pending.js)
  const {
    isOpen: isSelectiveAssigningModalOpen,
    openModal: openSelectiveAssigningModal,
    closeModal: closeSelectiveAssigningModal,
    data: selectiveAssigningModalData, // Might not be needed here, review usage
    setData: setSelectiveAssigningModalData, // Might not be needed here, review usage
  } = useModalState();

  // temp alert logic
  // const [first, set]

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(25);
  const [count, setCount] = useState(0);
  const [selectedSankalpData, setSelectedSankalpData] = useState(null);
  const [filter, setFilter] = useState({
    from: null, // dayjs("01-01-2023"),
    to: null, //dayjs(),
    cfrom: null,
    cto: null,

    // motherStatus: "Any",
    // telecaller: "Any",
    // week: getWeekOfMonth(),
  });
  const [openUnassign, setOpenUnassign] = useState(false);
  const [unAssigning, setUnAssigning] = useState(false);
  const [unAssignCompleted, setUnassignCompleted] = useState(null);

  const [textFile, setTextFile] = useState(null);
  const [excelFile, setExcelFile] = useState(null);

  // STATE AND METHODS FOR BULK ASSIGNMENT

  // html elements
  const textFileInputRef = useRef(null);
  const excelFileInputRef = useRef(null);

  const [bulkAssignOpen, setBulkAssignOpen] = useState(false);
  const [bulkAssignData, setBulkAssignData] = useState(new Map());

  const [bulkAssignMode, setBulkAssignMode] = useState(null);

  const handleBulkAssignModelOpen = () => setBulkAssignOpen(true);
  const handleBulkAssignModelClose = () => setBulkAssignOpen(false);

  const handleBulkAssignMode = (mode) => {
    setBulkAssignMode(mode);
  };

  const manualInputBulkAssignSaveHandler = (data) => {
    // data will be a string
    // first remove any empty space from left and right
    let stringMotherIds = data.trim();

    // then split the string by comma
    let commaSeparatedMotherIds = stringMotherIds.split(",");

    // now each element of the array is a string

    // need to trim each element of the array
    let trimmedMotherIds = commaSeparatedMotherIds.map((id) => id.trim());

    // need to remove the empty strings
    let filteredMotherIds = trimmedMotherIds.filter((id) => id.trim() !== "");

    // now add the filteredMotherIds to the bulkAssignData
    let newBulkAssignDataMap = new Map();

    // loop through the filteredMotherIds
    filteredMotherIds.forEach((id) => {
      newBulkAssignDataMap.set(id, id);
    });

    // now set the newBulkAssignDataMap to the bulkAssignData
    setBulkAssignData(newBulkAssignDataMap);

    setBulkAssignMode("show-list");

    console.log(filteredMotherIds);
  };

  const handleTextFileModeClick = () => {
    textFileInputRef.current.click();
  };

  const handleExcelFileModeClick = () => {
    excelFileInputRef.current.click();
  };

  // textFileInputRef.current &&
  //   textFileInputRef.current.addEventListener("change", (event) => {
  //     const file = event.target.files[0];
  //     console.log(file, "Selected file");

  //     if (file) {
  //       const reader = new FileReader();

  //       reader.onload = (e) => {
  //         const text = e.target.result;
  //         console.log("File contents:", text);

  //         // Process the text: split by commas or newlines, trim, and filter empty strings
  //         const processedIds = text
  //           .split(/[,\n]/)
  //           .map((id) => id.trim())
  //           .filter((id) => id !== "");

  //         // Create a new Map with the processed IDs
  //         const newBulkAssignData = new Map();
  //         processedIds.forEach((id) => {
  //           newBulkAssignData.set(id, id);
  //         });

  //         // Update the state with the new Map
  //         setBulkAssignData(newBulkAssignData);
  //         console.log("Processed IDs:", Array.from(newBulkAssignData.keys()));

  //         // Change the mode to show the list
  //         setBulkAssignMode("show-list");
  //       };

  //       reader.onerror = (e) => {
  //         console.error("Error reading file:", e);
  //       };

  //       reader.readAsText(file);
  //     }
  //   });

  useEffect(() => {
    const handleFileChange = (event) => {
      const file = event.target.files[0];
      console.log(file, "Selected file");

      if (file) {
        const reader = new FileReader();

        reader.onload = (e) => {
          const text = e.target.result;
          console.log("File contents:", text);

          // Process the text: split by commas or newlines, trim, and filter empty strings
          const processedIds = text
            .split(/[,\n]/)
            .map((id) => id.trim())
            .filter((id) => id !== "");

          // Create a new Map with the processed IDs
          const newBulkAssignData = new Map();
          processedIds.forEach((id) => {
            newBulkAssignData.set(id, id);
          });

          // Update the state with the new Map
          setBulkAssignData(newBulkAssignData);
          console.log("Processed IDs:", Array.from(newBulkAssignData.keys()));

          // Change the mode to show the list
          setBulkAssignMode("show-list");
        };

        reader.onerror = (e) => {
          console.error("Error reading file:", e);
        };

        reader.readAsText(file);
      }
    };

    const currentRef = textFileInputRef.current;
    if (currentRef) {
      currentRef.addEventListener("change", handleFileChange);
    }

    return () => {
      if (currentRef) {
        currentRef.removeEventListener("change", handleFileChange);
      }
    };
  }, []);

  // --- Methods for SelectedAssignDialog ---
  const assignSelectedCases = async () => {
    // Placeholder: Implement logic similar to active.js if needed
    console.log("Assigning selected cases...");
    // Example: Check if cases need unassigning first
    // const canBeAllocated = await selectedRowsThatCanBeAllocated(); // Need to implement this helper
    // if (canBeAllocated.size > 0) {
    //   setNeedToBeUnassignedCases(canBeAllocated);
    // } else {
    //   setActiveSelectedAssign("selected-agent"); // Or trigger the dialog logic
    //   setAssignSelectedCompleted(false);
    // }
    toast.info("Assign Selected Cases - Placeholder", {
      position: "top-center",
    });
    // For now, just open the dialog part for selecting agents directly if needed
    setActiveSelectedAssign("selected-agent");
    setAssignSelectedCompleted(false);
  };

  const handleRemoveStaticSelection = (id, motherID) => {
    // Placeholder: Implement logic similar to active.js
    console.log(
      `Removing static selection for ID: ${id}, MotherID: ${motherID}`
    );
    setStaticSelectedRows((prevStaticSelectedRows) => {
      const newStaticSelectedRows = new Map(prevStaticSelectedRows);
      newStaticSelectedRows.delete(id);
      // Or find by motherID if needed:
      // const matchingCase = Array.from(newStaticSelectedRows.values()).find(data => data.motherID === motherID);
      // if (matchingCase) newStaticSelectedRows.delete(matchingCase._id);
      return newStaticSelectedRows;
    });
    toast.info(`Removed selection: ${id}`, {
      position: "top-center",
      duration: 1000,
    });
  };
  // --- End Methods for SelectedAssignDialog ---

  useEffect(() => {
    const handleFileChange = (event) => {
      const file = event.target.files[0];
      console.log(file, "Selected file");

      if (file) {
        let formData = new FormData();
        formData.append("file", file);

        axios
          .post(API_HOST_CRM + "/bulk-mother-id-allocate", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((resp) => {
            console.log(resp);
          })
          .catch((e) => {
            console.log(e);
          });
      }
    };

    const currentRef = excelFileInputRef.current;
    if (currentRef) {
      currentRef.addEventListener("change", handleFileChange);
    }

    return () => {
      if (currentRef) {
        currentRef.removeEventListener("change", handleFileChange);
      }
    };
  }, []);

  const handleDeleteChip = (id) => {
    let newBulkAssignData = new Map(bulkAssignData);
    newBulkAssignData.delete(id);
    setBulkAssignData(newBulkAssignData);
  };

  // END OF STATE AND METHODS FOR BULK ASSIGNMENT
  // ===================================

  useEffect(() => {
    console.log(filter);
  }, [filter]);

  useEffect(() => {
    if (socket) {
      socket.on("case-update", (data) => {
        // getList(true);
        // debouncedGetList(true, filter);
      });
    }
    return () => {
      if (socket) {
        socket.removeAllListeners();
      }
    };
  }, [socket]);

  const getList = (keep) => {
    // if (!keep) {
    //   setData([]);
    // }

    // if (keep) {
    //   setFilter({ ...filter });
    // }
    setListLoading(true);
    axios
      .get(
        API_HOST_CRM +
          `/cases?limit=${rowsPerPage}` +
          // `&page=${page}&type=test` +
          `&page=${page}&type=${type}` +
          `&getids=${filter.from ? "yes" : "no"}` +
          `${
            filter.from
              ? `&from=${dayjs(filter.from).format("YYYY-MM-DD")}`
              : ""
          }` +
          `${filter.to ? `&to=${dayjs(filter.to).format("YYYY-MM-DD")}` : ""}` +
          `${
            filter.status
              ? `&status=${encodeURIComponent(JSON.stringify(filter.status))}`
              : ""
          }` +
          `${
            filter.district
              ? `&district=${encodeURIComponent(
                  JSON.stringify(filter.district)
                )}`
              : ""
          }` +
          `${
            filter.data_type
              ? `&data_type=${encodeURIComponent(filter.data_type)}`
              : ""
          }` +
          // `${filter.dataType ? `&dataType=${filter.dataType}` : ""}` +
          `${filter.motherID ? `&motherId=${filter.motherID}` : ""}` +
          `${filter.motherName ? `&motherName=${filter.motherName}` : ""}` +
          `${filter.contact ? `&contact=${filter.contact}` : ""}` +
          // `${filter.motherStatus ? `&motherStatus=${filter.motherStatus}` : ""}` +
          `${
            filter.motherStatus
              ? `&motherStatus=${encodeURIComponent(
                  JSON.stringify(filter.motherStatus)
                )}`
              : ""
          }` +
          // `${filter.telecaller ? `&telecaller=${filter.telecaller}` : ""}` +
          `${
            filter.telecaller
              ? `&telecaller=${encodeURIComponent(
                  JSON.stringify(filter.telecaller)
                )}`
              : ""
          }` +
          `${
            filter.allocatedToUser
              ? `&allocatedToUser=${encodeURIComponent(
                  JSON.stringify(filter.allocatedToUser)
                )}`
              : ""
          }` +
          `${
            filter.dateReceived ? `&dateReceived=${filter.dateReceived}` : ""
          }` +
          `${filter.nextCallDue ? `&nextCallDue=${filter.nextCallDue}` : ""}` +
          `${filter.callDate ? `&callDate=${filter.callDate}` : ""}` +
          `${
            filter.lastCallDate ? `&lastCallDate=${filter.lastCallDate}` : ""
          }` +
          `${filter.attempt ? `&attempt=${filter.attempt}` : ""}` +
          `${
            filter.transferredFrom
              ? `&transferredFrom=${filter.transferredFrom}`
              : ""
          }` +
          `${
            filter.transferStatus
              ? `&transferStatus=${filter.transferStatus}`
              : ""
          }` +
          `${
            filter.cfrom
              ? `&cfrom=${dayjs(filter.cfrom).format("YYYY-MM-DD")}`
              : ""
          }` +
          `${
            filter.cto ? `&cto=${dayjs(filter.cto).format("YYYY-MM-DD")}` : ""
          }` +
          `${filter.week ? `&week=${filter.week}` : ""}` +
          // `${filter.priority ? `&priority=${filter.priority}` : ""}` +
          `${
            filter.priority
              ? `&priority=${encodeURIComponent(
                  JSON.stringify(filter.priority)
                )}`
              : ""
          }`
      )
      .then((resp) => {
        if (resp.data && resp.data.success) {
          setData(resp.data.cases);
          setCount(resp.data.count);
          setAllFilteredIds(resp.data.ids);
        }
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => {
        setListLoading(false);
      });
  };

  const [debouncedGetList, isLoading] = useDebounce(getList, 300);

  useEffect(() => {
    debouncedGetList();
    // getList();
  }, [page, rowsPerPage, filter]);

  useEffect(() => {
    getList();
  }, []);

  //   useEffect(()=>{
  // if(data.length== 0){
  //   alert("no data bro")
  // }
  //   },[data])

  const exportMotherReport = (data) => {
    axios
      .get(
        API_HOST_CRM +
          `/export-motherData?id=${data.motherID}&from=${encodeURIComponent(
            dayjs(filter.from).format("YYYY-MM-DD")
          )}&to=${encodeURIComponent(dayjs(filter.to).format("YYYY-MM-DD"))}
				
				`,
        {
          responseType: "arraybuffer",
        }
      )
      .then((resp) => {
        if (resp) {
          const url = window.URL.createObjectURL(new Blob([resp.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `Mother_Report_${data.motherID}+${data.name}.xlsx`
          );
          document.body.appendChild(link);
          link.click();
          console.log(resp);
          link.remove();
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };

  useEffect(() => {
    console.log(listLoading, "listLoading");
  }, [listLoading]);

  return (
    <>
      <ToolbarWrapper>
        {" "}
        {/* Added */}
        <ToolBar
          name={heading}
          height={"3em"}
          buttons={[
            // Add the "Assign Selected" button
            {
              name: `Assign (${staticSelectedRows.size}) Selected`,
              disable: staticSelectedRows.size == 0,
              icon: () => <ArrowOutwardIcon sx={{ fontSize: "1.2em" }} />,
              onClick: () => {
                // Logic to open the dialog
                setAssignSelectedCompleted(false); // Reset completion state
                setActiveSelectedAssign(null); // Reset sub-view inside dialog
                openSelectiveAssigningModal(); // Open the main dialog
              },
            },
            // Keep existing buttons based on type
            // ...(type == "in-queue"
            //   ? [
            //     {
            //       name: unAssignCompleted
            //         ? "UnAssign Completed"
            //         : unAssigning
            //           ? `Unassigning.....`
            //           : `Unassign Selected (${selectedRows.length})`,
            //       disable: selectedRows.length == 0,
            //       icon: () => <BoltIcon sx={{ fontSize: "1.2em" }} />,
            //       onClick: () => {
            //         if (!unAssigning && !unAssignCompleted) {
            //           setUnassignAllFiltered(false)
            //           setOpenUnassign(true);
            //           setUnassignReason(null);
            //         }
            //       },
            //     },
            //     {
            //       name: unAssignCompleted
            //         ? "UnAssign Completed"
            //         : unAssigning
            //           ? `Unassigning.....`
            //           : `Unassign All Filtered (${count})`,
            //       disable: !filter.from,
            //       icon: () => <BoltIcon sx={{ fontSize: "1.2em" }} />,
            //       onClick: () => {
            //         if (!unAssigning && !unAssignCompleted) {
            //           setUnassignAllFiltered(true)
            //           setOpenUnassign(true);
            //           setUnassignReason(null);
            //         }
            //       },
            //     },
            //   ]
            //   : [])
          ]}
          // buttons={ // Original button logic commented out
          //   type == "in-queue"
          //     ? [
          //       {
          //         name: unAssignCompleted
          //           ? "UnAssign Completed"
          //           : unAssigning
          //             ? `Unassigning.....`
          //             : `Unassign Selected (${selectedRows.length})`, //assignCompleted
          //         // ? "Assign Completed"
          //         // : assigning
          //         // ? "Assigning....."
          //         // : "Assign Auto",
          //         // type: 'chip',
          //         disable: selectedRows.length == 0,
          //         icon: () => <BoltIcon sx={{ fontSize: "1.2em" }} />,
          //         onClick: () => {
          //           if (!unAssigning && !unAssignCompleted) {
          //             setUnassignAllFiltered(false)
          //             setOpenUnassign(true);
          //             setUnassignReason(null);
          //           }
          //         },
          //       },
          //       {
          //         name: unAssignCompleted
          //           ? "UnAssign Completed"
          //           : unAssigning
          //             ? `Unassigning.....`
          //             : `Unassign All Filtered (${count})`, //assignCompleted
          //         // ? "Assign Completed"
          //         // : assigning
          //         // ? "Assigning....."
          //         // : "Assign Auto",
          //         // type: 'chip',
          //         disable: !filter.from,//Object.values(filter).filter(e=> e).length ==0,
          //         icon: () => <BoltIcon sx={{ fontSize: "1.2em" }} />,
          //         onClick: () => {
          //           if (!unAssigning && !unAssignCompleted) {
          //             setUnassignAllFiltered(true)
          //             setOpenUnassign(true);
          //             setUnassignReason(null);
          //           }
          //         },
          //       },
          //       // {
          //       //   name: "Bulk Assign",
          //       //   onClick: () => {
          //       //     // open the bulk assign modal
          //       //     handleBulkAssignModelOpen();
          //       //   },
          //       // },
          //     ]
          //     : []
          // }
          onClearFilter={() => {
            setFilter({
              from: null,
              to: null,
              cfrom: null,
              cto: null,
              firstReceived: null,
              motherName: "",
              motherID: "",
              contact: "",
              status: null,
              motherStatus: null,
              telecaller: null,
              district: null,
            });
          }}
          filters={[
            {
              field: {
                name: "from",
                type: "date",
                label: "Assign From",
              },
              onChange: (name, value) => {
                filter[name] = value;
                setFilter({ ...filter });
              },
              state: filter,
            },
            {
              field: {
                name: "to",
                type: "date",
                label: "Assign To",
              },
              onChange: (name, value) => {
                filter[name] = value;
                setFilter({ ...filter });
              },
              state: filter,
            },
            {
              minWidth: 150,
              field: {
                name: "data_type",
                type: "select",
                label: "Data Type",
                option: {
                  key: "DataTypes",
                  value: "_id",
                  label: "name",
                },
                noMb: true,
              },
              data: {
                DataTypes: [
                  { _id: "any", name: "Any" },
                    // Data type renaming
                  {
                    _id: "new_data_current_month",
                    name: "New Data Current Month",
                  },
                  {
                    _id: "new_data_current_month_delivered",
                    name: "New Data Current Month Delivered",
                  },
                  {
                    _id: "previous_month_unreached_calls",
                    name: "Previous Month Unreached Calls",
                  },
                  {
                    _id: "previous_month_pending_calls",
                    name: "Previous Month Pending Calls",
                  },
                  {
                    _id: "followup_calls_40_days",
                    name: "Follow-up Calls 40 Days",
                  },
                  {
                    _id: "followup_calls_90_days",
                    name: "Follow-up Calls 90 Days",
                  }
                  // End Data type renaming
                  // Not removing the comments because i am petty. This is suppose to be in "production". WHAT A MESS, BOTH THIS PROJECT AND THE PEOPLE WHO WERE MANAGING IT.
                  // { _id: "followup_calls", name: "Follow-up calls" },
                  // // { _id: "followup_calls_delivered", name: "Follow-up calls(Delivered)" },
                  // { _id: "new_data", name: "New Data" },
                  // {
                  //   _id: "previously_unreached",
                  //   name: "Previously Unreached from previous months",
                  // },
                  // {
                  //   _id: "previously_unattempted",
                  //   name: "Previously Pending from previous months",
                  // },
                  // { _id: "delivered", name: "Delivered(Current Month)" },
                  // {
                  //   _id: "previously_delivered",
                  //   name: "Delivered(Not Current Month)",
                  // },
                  // {
                  //   _id: "previously_unreached_delivered",
                  //   name: "Previously Unreached from previous months(Delivered)",
                  // },
                  // {
                  //   _id: "previously_unattempted_delivered",
                  //   name: "Previously Pending from previous months(Delivered)",
                  // },
                  // {
                  //   _id: "followup_calls_delivered",
                  //   name: "Followup calls(Delivered)",
                  // },
                ],
              },
              onChange: (name, value) => {
                filter[name] = value;
                console.log("-------------------------------->33");
                setFilter({ ...filter });
              },
              state: filter,
            },
          ]}
        />
      </ToolbarWrapper>{" "}
      {/* Added */}
      {/* HIDDEN FILE INPUTS */}
      <input
        type="file"
        id="text-file-input"
        style={{ display: "none" }}
        ref={textFileInputRef}
      />
      <input
        type="file"
        id="excel-file-input"
        style={{ display: "none" }}
        ref={excelFileInputRef}
      />
      {/* END OF HIDDEN FILE INPUTS */}
      <Box sx={{ mt: 0 }}>
        <Grid
          isLoading={listLoading}
          data={data}
          // Add static selection props to Grid
          staticSelectedRows={staticSelectedRows}
          setStaticSelectedRows={setStaticSelectedRows}
          onSelectChange={(selected) => {
            // Keep existing onSelectChange if needed
            console.log(selected);
            setSelectedRows(selected); // Keep if selectedRows state is still used elsewhere
          }}
          // filter={filter}
          columns={[
            ...filterColumns(
              [
                {
                  id: "motherID",
                  showFilter: true,
                },
                {
                  id: "name",
                  showFilter: true,
                },
                {
                  id: "contact",
                  showFilter: true,
                },
                {
                  id: "districtName",
                  showFilter: true,
                  type: "select",
                },
                // {
                //   id: "dataType",
                //   showFilter: true,
                //   type: "select",
                // },
                {
                  id: "dateReceived",
                  showFilter: true,
                },
                {
                  id: "lastCallDate",
                  showFilter: true,
                },
                {
                  id: "callDate",
                  showFilter: true,
                },
                {
                  id: "priority",
                  showFilter: true,
                  type: "select",
                },
                {
                  id: "allocatedToUser",
                  // showFilter: true,
                  isSelect: true,
                },
                {
                  id: "motherStatus",
                  showFilter: true,
                  type: "select",
                },
                {
                  id: "nextCallDue",
                  showFilter: true,
                },
                ...[
                  !["in-queue", "on-call"].includes(type)
                    ? {
                        id: "status",
                        showFilter: true,
                        type: "select",
                      }
                    : {},
                ],
                {
                  id: "attempt",
                  showFilter: true,
                  minWidth: 150,
                },
                {
                  id: "transferredFrom",
                  showFilter: true,
                  type: "select",
                  minWidth: 200,
                },
                {
                  id: "transferStatus",
                  showFilter: true,
                  minWidth: 150,
                },
              ],
              filter,
              setFilter,
              { Districts, users, map }
            ),
          ]}
          pagination={{
            rowsPerPageOptions: [10, 25, 50, 100, 200],
            page,
            rowsPerPage,
            onPageChange: (event, newPage) => {
              setPage(newPage);
            },
            onRowsPerPageChange: (event) => {
              setRowsPerPage(+event.target.value);
              setPage(0);
            },
            count,
          }}
        ></Grid>
      </Box>
      <Modal
        open={open}
        handleClose={() => {
          setOpen(false);
        }}
        head={`Sankalp Data`}
        buttons={[
          {
            name: "Cancel",
            onClick: () => {
              setOpen(false);
            },
          },
        ]}
      >
        {selectedSankalpData &&
          selectedSankalpData.sankalpData &&
          Object.keys(selectedSankalpData.sankalpData).map((s, i) => {
            const map = {
              pregStatus: "Pregnancy Status",
              advice: "Advice",
              pregnancyNumber: "Pregnancy Number",
              pretermDelivery: "Pre-term Delivery",
              nearResidance: "Near By Residence",
              trimester: "Trimester",
            };
            return (
              <Box key={i} sx={{ display: "flex", mt: 1 }}>
                <Typography variant="p">{map[s] || s}: </Typography>&nbsp;
                <Typography
                  variant="p"
                  sx={{ color: "grey", fontSize: ".9em" }}
                >
                  {selectedSankalpData.sankalpData[s]}
                </Typography>
              </Box>
            );
          })}
      </Modal>
      <Modal
        open={openUnassign}
        handleClose={() => {
          // setOpenUnassign(false);
        }}
        head={`Unassign Cases`}
        buttons={[
          ...(unAssigning
            ? []
            : [
                {
                  name: "Unassign",
                  onClick: () => {
                    setUnAssigning(true);
                    setOpenUnassign(false);

                    axios
                      .put(API_HOST_CRM + "/ecd/unassign-pendings", {
                        caseIds: unassignAllFiltered
                          ? allFilteredIds
                          : selectedRows.map((e) => e._id),
                        reason: unassignReason,
                      })
                      .then((resp) => {
                        if (resp.data && resp.data.success) {
                          getList(true);
                          setUnAssigning(false);
                          setUnassignCompleted(true);
                          setTimeout(() => {
                            setUnassignCompleted(false);
                          }, 2000);
                        }
                        setUnAssigning(false);
                      })
                      .catch((e) => {
                        console.log(e);
                        setUnAssigning(false);
                      });
                  },
                },
                {
                  name: "Cancel",
                  onClick: () => {
                    setOpenUnassign(false);
                  },
                },
              ]),
        ]}
      >
        <Typography sx={{ fontWeight: "bold" }}>
          Total selected cases: {selectedRows.length || 0}
        </Typography>
        <Box sx={{ mt: 2 }}>
          <SelectA
            field={{
              type: "select",
              label: "Unassign Reson",
              option: { key: "UnassignReasons", value: "_id", label: "name" },
              name: "unassignReason",
            }}
            data={{
              UnassignReasons,
            }}
            onChange={(name, value, multiple) => {
              setUnassignReason(value);
            }}
            value={unassignReason}
          />
        </Box>
      </Modal>
      {/* MODAL FOR BULK ASSIGNMENT */}
      <BulkModalAssign
        bulkAssignOpen={bulkAssignOpen}
        handleBulkAssignModelClose={handleBulkAssignModelClose}
      />
      {/* <MuiModal
        open={bulkAssignOpen}
        onClose={handleBulkAssignModelClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={centeredModalStyle}>
          <IconButton
            onClick={handleBulkAssignModelClose}
            sx={{ position: "absolute", top: 8, right: 8 }}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
          <Stack direction="column" spacing={2} position="relative">
            <Stack direction="row" spacing={2} justifyContent="center">
              <Button
                variant="contained"
                onClick={() => {
                  handleBulkAssignMode("text");
                  handleTextFileModeClick();
                }}
                sx={{
                  backgroundColor:
                    bulkAssignMode === "text" ? "#0000CC" : "primary",
                }}
              >
                Upload Text File
              </Button>
              <Button
                variant="contained"
                onClick={() => {
                  handleBulkAssignMode("excel");
                  handleExcelFileModeClick();
                }}
                sx={{
                  backgroundColor:
                    bulkAssignMode === "excel" ? "#0000CC" : "primary",
                }}
              >
                Upload Excel Sheet
              </Button>
              <Button
                variant="contained"
                onClick={() => handleBulkAssignMode("manual")}
                sx={{
                  backgroundColor:
                    bulkAssignMode === "manual" ? "#0000CC" : "primary",
                }}
              >
                Enter Manually
              </Button>
            </Stack>

            {bulkAssignMode === "manual" && (
              <Stack direction={"column"}>
                <ManualInputBulkAssign
                  manualInputBulkAssignSaveHandler={
                    manualInputBulkAssignSaveHandler
                  }
                />
              </Stack>
            )}

            {bulkAssignMode === "excel" && <div>Current Mode: Excel</div>}

            {bulkAssignMode === "text" && (
              <Stack direction={"column"}>
                <div>Current Mode: Text</div>
              </Stack>
            )}

            {bulkAssignMode === "show-list" && (
              <FormattedIdList
                idListMap={bulkAssignData}
                onDelete={handleDeleteChip}
              />
            )}
          </Stack>
        </Box>
      </MuiModal> */}
      {/* Add the SelectedAssignDialog instance */}
      {isSelectiveAssigningModalOpen && (
        <SelectedAssignDialog
          type={type}
          open={isSelectiveAssigningModalOpen}
          handleClose={closeSelectiveAssigningModal}
          staticSelectedRows={staticSelectedRows}
          setStaticSelectedRows={setStaticSelectedRows}
          activeSelectedAssign={activeSelectedAssign}
          setActiveSelectedAssign={setActiveSelectedAssign}
          assignSelectedCases={assignSelectedCases} // Pass method
          isFetchingSelectedCasesDetails={isFetchingSelectedCasesDetails} // Pass state
          needToBeUnassignedCases={needToBeUnassignedCases} // Pass state
          // setNeedToBeUnassignedCases={setNeedToBeUnassignedCases} // Pass state setter
          // unassignSelectedRows={unassignSelectedRows} // Pass method
          // isUnassigning={isUnassigningSelected} // Pass renamed state
          handleRemoveStaticSelection={handleRemoveStaticSelection} // Pass method
          assignSelectedCompleted={assignSelectedCompleted} // Pass state
          assigningSelected={assigningSelected} // Pass state
          setAssigningSelected={setAssigningSelected} // Pass state setter
          setAssignSelectedCompleted={setAssignSelectedCompleted} // Pass state setter
          selectedAgents={selectedAgents} // Pass state
          setSelectedAgents={setSelectedAgents} // Pass state setter
          users={users} // Pass users from Redux
          getList={getList} // Pass getList method
        />
      )}
    </>
  );
};
